import React, { useEffect } from "react";
import InvoiceCard from "./common/InvoiceCard";
import Footer from "./Footer";
import HeaderInner from "./HeaderInner";
import configureStore from "../../../store/configureStore";
import { useDispatch, useSelector } from "react-redux";
import { get_sales_invoice } from "./actions/action-salesInvoice";
import Loader from "../../common/Loader";
import CommonSnackBar from "../../common/CommonSnackBar";
import { history } from "../../../reducers";
import AddIcon from "@material-ui/icons/Add";

const store = configureStore();

function InvoiceList() {
  const dispatch = useDispatch();
  const { activeOuid } = store.getState().permission;
  const { salesInvoice, showGlobalLoader } = useSelector(
    (state) => state.salesInvoice
  );

  function renderInvoiceList(salesInvoice) {
    if (salesInvoice) {
      return salesInvoice.map((item) => (
        <InvoiceCard key={item.id} item={item} />
      ));
    } else {
      return <>No Sales invoices found</>;
    }
  }

  useEffect(() => {
    console.log("inuseEffect");
    const fetchData = async (dispatch) => {
      await dispatch(get_sales_invoice("", activeOuid));
    };
    fetchData(dispatch);
  }, [dispatch]);

  return (
    <div>
      <HeaderInner pageTitle="invoices " />
      <div className=" HrmAppPage container--narrow mt FBAppPage">
        {showGlobalLoader ? <Loader /> : renderInvoiceList(salesInvoice)}

        <div className="AppFloatingButtonWrapper t-r">
          <button
            className="round_btn bg_blue "
            onClick={() => history.push(`/${activeOuid}/create-invoice`)}
          >
            <AddIcon />
          </button>
        </div>
      </div>
      <Footer />
      <CommonSnackBar />
    </div>
  );
}

export default InvoiceList;
